'use client';

import { c as _c } from "react/compiler-runtime";
import type { SxProps } from '@mui/material';
import { ButtonBase, type ButtonBaseProps, Typography } from '@mui/material';
import type { ReactNode } from 'react';
export type ChipProps = ButtonBaseProps & {
  label: ReactNode;
  showCloseIcon?: boolean;
};
const BASE_STYLES: SxProps = {
  display: 'inline-flex',
  alignItems: 'center',
  borderRadius: '99px',
  height: '32px',
  backgroundColor: '#ebebec',
  px: 1.5,
  gap: 1,
  '&.Mui-disabled': {
    opacity: 0.5,
    cursor: 'not-allowed'
  }
};
const Chip = t0 => {
  const $ = _c(23);
  let ariaLabel;
  let buttonBaseProps;
  let label;
  let onClick;
  let sx;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      label,
      onClick,
      showCloseIcon: t1,
      disabled: t2,
      "aria-label": ariaLabel,
      sx,
      ...buttonBaseProps
    } = t0);
    $[0] = t0;
    $[1] = ariaLabel;
    $[2] = buttonBaseProps;
    $[3] = label;
    $[4] = onClick;
    $[5] = sx;
    $[6] = t1;
    $[7] = t2;
  } else {
    ariaLabel = $[1];
    buttonBaseProps = $[2];
    label = $[3];
    onClick = $[4];
    sx = $[5];
    t1 = $[6];
    t2 = $[7];
  }
  const showCloseIcon = t1 === undefined ? false : t1;
  const disabled = t2 === undefined ? false : t2;
  const resolvedAriaLabel = ariaLabel ?? (showCloseIcon && typeof label === "string" ? `Remove ${label}` : undefined);
  let t3;
  if ($[8] !== sx) {
    t3 = sx ? [BASE_STYLES, sx] : BASE_STYLES;
    $[8] = sx;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const t4 = t3 as SxProps;
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      color: "text.secondary",
      fontSize: "14px"
    };
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== label) {
    t6 = <Typography component="span" variant="textSmallBold" sx={t5}>{label}</Typography>;
    $[11] = label;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== showCloseIcon) {
    t7 = showCloseIcon && <span aria-hidden="true" className="mask-icon mask-icon-close" style={{
      width: "24px",
      height: "24px",
      backgroundColor: "#64666A"
    }} />;
    $[13] = showCloseIcon;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== buttonBaseProps || $[16] !== disabled || $[17] !== onClick || $[18] !== resolvedAriaLabel || $[19] !== t4 || $[20] !== t6 || $[21] !== t7) {
    t8 = <ButtonBase disableRipple={true} disabled={disabled} onClick={onClick} aria-label={resolvedAriaLabel} sx={t4} {...buttonBaseProps}>{t6}{t7}</ButtonBase>;
    $[15] = buttonBaseProps;
    $[16] = disabled;
    $[17] = onClick;
    $[18] = resolvedAriaLabel;
    $[19] = t4;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
};
export default Chip;